import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { participantsSharedI18n } from '../../../../services/models/participants.service'
import StepperInputComponent from '../../../shared/stepper-input.component'

interface Props {
  store: StoreProps['store']
  data: Pick<StoreProps['data'], 'offeredService' | 'participantsNumber'>
}

export default function CastingParticipantsNumberInputComponent ({ store, data: { offeredService, participantsNumber } }: Props) {
  const i18nParticipants = React.useMemo(() => participantsSharedI18n(offeredService.participant_terminology).scope('CastingParticipantsNumberInputComponent'), [offeredService.participant_terminology])

  return <StepperInputComponent
    formatter={ value => i18nParticipants.t('count', { count: value }) }
    style={{ marginBottom: '0.75em' }}
    name="participants_number"
    value={ participantsNumber }
    onChange={ value => store.set({ participantsNumber: value }) }
    min={ offeredService.participant_min }
    max={ offeredService.participant_max || 999 } 
  />
}
